import React from 'react';
import { Clock3Icon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="bg-[#09281d] px-5 py-16" data-id="element-237" data-mp="2sk41l62s7846">
      <div className="mx-auto max-w-2xl border-2 border-red-400 bg-[#10372a] p-8 text-center sm:p-11" data-id="element-238" data-mp="36ahc9g7250x7">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.2em] text-red-300" data-id="element-239" data-mp="31ipi6vop0d2b">
          <Clock3Icon className="h-4 w-4" data-id="element-240" data-mp="3g7c6vo07mh67" /> Oferta de lanzamiento por tiempo
          limitado
        </p>
        <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-241" data-mp="3b7ze6mmnqfvp">
          El precio especial termina en:
        </h2>
        <div className="my-9" data-id="element-242" data-mp="3l7htgprmhdhf">
          <CountdownTimer size="large" dark data-id="element-243" data-mp="3l89pu2t1nf8r" />
        </div>
        <p className="font-semibold text-white" data-id="element-244" data-mp="1uuspaott01we">
          Aprovecha hoy el acceso de por vida a los 12 tomos y los 5 bonos
          estratégicos.
        </p>
        <div className="mx-auto mt-7 max-w-sm" data-id="element-245" data-mp="1qus0qbczqabm">
          <div className="h-3 overflow-hidden border border-red-400/50 bg-[#061b13]" data-id="element-246" data-mp="2sty2npwe1qod">
            <div className="h-full w-[72%] bg-red-500" data-id="element-247" data-mp="2xsr4gl2bbt8p" />
          </div>
          <div className="mt-3 flex justify-between text-[10px] font-bold uppercase tracking-widest" data-id="element-248" data-mp="2xt0u27jg3ydv">
            <span className="text-red-300" data-id="element-249" data-mp="32qj3dz1dkfme">Oferta vigente por hoy</span>
            <span className="text-slate-300" data-id="element-250" data-mp="37jccez3vma4a">72% reservado</span>
          </div>
        </div>
      </div>
    </section>;
}